import logo from '../images/png/Logo.png';
import mail from "../images/png/mail.png";
import phone from "../images/png/phone.png";
import tiktok from "../images/png/tiktok.webp";
import instagram from "./png/Instagram_icon.png";
import whatsApp from "./png/WhatsApp_icon.png";
import viber from "./png/viber.webp";
import aboutImg from "./png/aboutImg.png";
import aboutMeImg from "./png/aboutMe.jpg";
import homeImg2 from "./png/homePageImg2.webp";
import homeImg3 from "./png/homePage3.jpg";
import homeImg4 from "./png/homePageImg4.jpg";
import homeImg5 from "./png/homePageImg5jpg.jpg";
import workers from "./png/workers.jpg";
import servicesImg1 from "./png/ServicesImg/Img1.jpg";
import servicesImg2 from './png/ServicesImg/img2.jpg'
import servicesImg3 from './png/ServicesImg/img3.jpg'
import servicesImg4 from "./png/ServicesImg/img4.jpg";
import faceBook from "./png/facebook.png"




export const imgs = {
  logo,
  mail,
  phone,
  tiktok,
  instagram,
  whatsApp,
  viber,
  aboutImg,
  aboutMeImg,
  aboutMeImg,
  faceBook,
  homeImgss: {
    aboutImg,
    homeImg2,
    homeImg3,
    homeImg4,
    homeImg5,
    workers,
  },
  services: {
    servicesImg1,
    servicesImg2,
    servicesImg3,
    servicesImg4,
  },
};

